import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestAuth } from '../../store/auth/auth.thunks'
import { requestRecaptcha } from '../../store/recaptcha/recaptcha.thunks'
import {
  resendOTP,
  verifyOTP,
  registerNew,
  resetOtp,
  registerAffiliate,
  getAffUserCount,
  getLast5AffComm,
  getAffUserTodayPL,
  getAffUsersList,
  getUserAffCode,
  getTop5LossUsers,
  getAffUserSportWisePL,
  getAffUserCreatedCountDateWise,
  getMyAffComm,
  getAffSpecificUserSportWisePL,
  getAffBonusSetting,
  postNumberSignUp,
} from '../../store/signUp/signUp.thunks'
import { getVerifyOtp } from '../../store/forgotPassword/forgotPassword.thunks'

export const connectAffiliate = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      auth: state.auth,
      tab: state.loginNew.tab,
      signUp: state.signUp,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestAuth,
      requestRecaptcha,
      postNumberSignUp,
      resendOTP,
      verifyOTP,
      getVerifyOtp,
      resetOtp,
      registerNew,
      registerAffiliate,
      getAffUserCount,
      getLast5AffComm,
      getAffUserTodayPL,
      getAffUsersList,
      getUserAffCode,
      getTop5LossUsers,
      getAffUserSportWisePL,
      getAffUserCreatedCountDateWise,
      getMyAffComm,
      getAffSpecificUserSportWisePL,
      getAffBonusSetting,
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
